/**
 * Application constants
 */

export const APP_NAME = "Template App";

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
} as const;

export const QUERY_STALE_TIME = {
  SHORT: 1 * 60 * 1000, // 1 minute
  MEDIUM: 5 * 60 * 1000, // 5 minutes
  LONG: 30 * 60 * 1000, // 30 minutes
} as const;

/** Default limit for GraphQL list queries (fetch all / dropdowns). */
export const GRAPHQL_QUERY_LIMIT = 25;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 20, 25, 50, 100, 500],
} as const;
